module.exports = __webpack_public_path__ + "static/img/community08.6ac16be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community08.jpg
// module id = oMMR
// module chunks = 0